import UserConstants from 'constants/UserConstants';
import {getLocaleName} from 'i18n/LanguageTags';
import notifications from 'notifications';
import preferences from 'Preferences';
import {USER_EDIT_DATE_FORMAT} from 'util/DateConstants';
import {
  getLocaleInputFormats,
  isValidDate,
  tryParseAndFormatDatetimeWithUserLanguageTag,
  tryParseAndFormatDateWithUserLanguageTag,
} from 'util/DateUtil';
import {tryParseNumberWithUserNumberFormat} from 'util/numbers/NumberParsingUtil';

const {LANGUAGE_PREFERENCE_KEY} = UserConstants;

/**
 * Tries to parse the string input as a number according to user's LanguageTag.
 * If that fails, tries to parse the string input as a date/datetime according to user's LanguageTag.
 * Parses with default number parsing format if shadowMode = True
 * @returns The parsed number/date(time) as a string date formatted according to the user locale if
 *          formatDateWithUserLocale is true, or as ISO format if formatDateWithUserLocale is false.
 *          Returns null if it fails to parse.
 */
export function tryLocaleAwareParseText(text: string, formatDateWithUserLocale: boolean): string | null {
  const parsedNumber = tryParseNumberWithUserNumberFormat(text);
  if (parsedNumber != null) {
    return parsedNumber;
  }
  if (
    isValidDate({
      textValue: text,
      min: null,
      max: null,
      validDateFormats: [USER_EDIT_DATE_FORMAT, ...getLocaleInputFormats(false)],
    })
  ) {
    return tryParseAndFormatDateWithUserLanguageTag(text, formatDateWithUserLocale);
  } else {
    return tryParseAndFormatDatetimeWithUserLanguageTag(text, formatDateWithUserLocale);
  }
}

export function notifyTextHasBeenLocalized(): void {
  const localeName = getLocaleName(preferences.get(LANGUAGE_PREFERENCE_KEY));
  notifications.success(
    `Numbers and dates have been parsed according to the current locale "${localeName}".`
  );
}
